import React from 'react'
import Title from '../../../../../../components/typography/title.component'
import schema from '../../constants/create-edit-schema.constants'
import Button from '../../../../../../components/buttons/buttons.component'
import Container from '../../../../../../components/layout/container.component'
import ProductData from './../../components/product-data.component'
import ProductImages from './../../components/product-images.component'
import PaymentConditions from './../../components/payment-conditions/payment-conditions.component'
import AccordionSecondary from '../../../../../../components/accordion/accordion-secondary.component'
import { Formik } from 'formik'
import { routes } from '../../../../../../constants/routes.constants'
import { history } from './../../../../../../helpers/history'
import { connect } from 'react-redux'
import { getParams } from '../../functions/create-edit.functions'
import { withRouter } from 'react-router-dom'
import { toastActions } from './../../../../../../actions'
import { ButtonContainer } from '../../components/styled-components'
import { bindActionCreators } from 'redux'
import { StoreProductService } from './../../../../../../services'
import { Creators as SiteCreators } from '../../../../../../ducks/site/site'

const initialValues = {
	name: '',
	quantity: '',
	description: '',
	spotlightOrder: '',
	price: 0,
	active: 1,
	points: 0,
	forSubscribers: 0
}

class StoreProductCreatePageComponent extends React.Component {
	constructor(props) {
		super(props)

		this.onSubmit = onSubmit.bind(this)
		this.getParams = getParams.bind(this)
		this.renderFormik = renderFormik.bind(this)
		this.handleCreated = handleCreated.bind(this)
		this.getAccordionItems = getAccordionItems.bind(this)
		this.setGetProductImages = setGetProductImages.bind(this)
		this.setGetPaymentConditions = setGetPaymentConditions.bind(this)
	}

	componentDidMount() {
		this.accordion.openAll()
	}

	render() {
		return (
			<Container medium>
				<Title>Inclusão de produto Loja Muviflex</Title>
				<Formik
					ref={'form'}
					onSubmit={this.onSubmit}
					validationSchema={schema}
					render={this.renderFormik}
					initialValues={initialValues}
				/>
				<ButtonContainer>
					<Button
						primary
						type={'button'}
						onClick={() => this.refs.form.submitForm()}>
						Salvar
					</Button>
				</ButtonContainer>
			</Container>
		)
	}
}

function onSubmit({ name, quantity, description, spotlightOrder }) {
	const params = this.getParams({ name, quantity, description, spotlightOrder })
	if (params != undefined)
		StoreProductService.create(params).then(this.handleCreated)
}

function handleCreated({ success, errors }) {
	if (success) {
		this.props.toastSuccess({ message: 'Produto criado com sucesso' })
		history.push(`${routes.ADMIN}/loja-moveflex`)
	} else this.props.toastError({ message: errors.shift() })
}

function renderFormik(props) {
	return (
		<AccordionSecondary
			noAnimated
			noClickable
			arrow={false}
			multiple={false}
			ref={e => (this.accordion = e)}
			items={this.getAccordionItems(props)}
		/>
	)
}

function getAccordionItems(props) {
	return [
		{
			title: 'Dados do produto',
			content: <ProductData {...props} />,
			initiallyOpened: true
		},
		{
			title: 'Imagens do produto',
			content: <ProductImages sendData={this.setGetProductImages} />,
			initiallyOpened: true
		},
		{
			title: 'Condições de pagamento',
			content: (
				<PaymentConditions
					sendData={this.setGetPaymentConditions}
					{...props}
				/>
			),
			initiallyOpened: true
		}
	]
}

function setGetProductImages(getProductImages) {
	this.getProductImages = getProductImages
}

function setGetPaymentConditions(getPaymentConditions) {
	this.getPaymentConditions = getPaymentConditions
}

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			toastError: toastActions.danger,
			toastSuccess: toastActions.success,
			hideLoading: SiteCreators.hideLoading,
			showLoading: SiteCreators.showLoading
		},
		dispatch
	)

const connectedStoreProductCreatePageComponent = withRouter(
	connect(
		null,
		mapDispatchToProps
	)(StoreProductCreatePageComponent)
)

export { connectedStoreProductCreatePageComponent as ModuleRootComponent }
